export default __webpack_public_path__ + "static/pin-b4919eca5ed62d6d0303d8645da42dec.svg";